import { standortUrlSelector } from '../../../selectors/url';
import { serviceLandingpageResponseSelector } from '../../../selectors/standort/service/serviceLandingpage';
import { shouldFetch } from '../../../fetchStatus';
import {
    FETCH_SERVICE_LANDINGPAGE_FAILURE,
    FETCH_SERVICE_LANDINGPAGE_REQUEST,
    FETCH_SERVICE_LANDINGPAGE_SUCCESS,
} from '../../../actionTypes';
import { apiClient } from '../../../../helpers/apiHelperV2';

export const fetchServiceLandingpageIfNeeded = ({ serviceUrl }) => {
    return async function (dispatch, getState) {
        if (!serviceUrl) return;

        const state = getState();

        const standortUrl = standortUrlSelector(state);
        const serviceLandingpageResponse = serviceLandingpageResponseSelector(state, { serviceUrl });

        const params = { standortUrl, serviceUrl };

        if (shouldFetch(serviceLandingpageResponse.status)) {
            dispatch({
                type: FETCH_SERVICE_LANDINGPAGE_REQUEST,
                payload: params,
            });
            try {
                const res = await apiClient.get('/api/v1/getLandingPageContent', {
                    params,
                });
                dispatch({
                    type: FETCH_SERVICE_LANDINGPAGE_SUCCESS,
                    payload: { ...params, content: res.data },
                });
            } catch (error) {
                dispatch({
                    type: FETCH_SERVICE_LANDINGPAGE_FAILURE,
                    payload: { ...params, error },
                });
            }
        }
    };
};
